/* eslint-disable @typescript-eslint/no-explicit-any */
import { TDeviceType } from '@cian/ui-kit';
import { Title } from '../Title';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { caPlayVideo } from 'shared/components/tracking';
import { useEffect } from 'react';

interface IVideoBlockProps {
  buttonLink: JSX.Element;
  device: TDeviceType;
  playerRef: React.RefObject<HTMLIFrameElement>;
  iframeLink: string;
}

export const VideoBlock: React.FC<IVideoBlockProps> = ({ buttonLink, device, playerRef, iframeLink }) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.VK) {
      const player = window.VK.VideoPlayer(playerRef.current);

      player.on('started', () => {
        caPlayVideo(device);
      });
    }
  }, [playerRef, device]);

  return (
    <div className={clsx(style['container'], style[device])}>
      <Title>Узнайте больше о скидке на ипотеку из нашего видеоролика</Title>
      <div className={style['video-container']}>
        <iframe
          ref={playerRef}
          src={iframeLink}
          width="100%"
          height="100%"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
          frameBorder="0"
        ></iframe>
      </div>
      <div className={style['btn']}>{buttonLink}</div>
    </div>
  );
};
